import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://maestros.ebookditales.com/cart/44752368664712:1';
interface CTAButtonProps {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  subtext,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) onClick();
    window.open(CHECKOUT_URL, '_blank');
  };
  return <div className="flex justify-center w-full" data-id="element-235">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={`flex flex-col items-center justify-center px-8 py-4 bg-green-600 hover:bg-green-500 text-white rounded-lg shadow-xl border-b-4 border-green-800 transition-all ${className}`} data-id="element-236">
        <span className="text-xl md:text-2xl font-bold uppercase tracking-wide flex items-center gap-2" data-id="element-237">
          {children} <ArrowRight className="w-6 h-6" data-id="element-238" />
        </span>
        {subtext && <span className="text-sm md:text-base font-medium opacity-90 mt-1" data-id="element-239">
            {subtext}
          </span>}
      </motion.button>
    </div>;
}